module.exports = __webpack_public_path__ + "media/images/emblems/Vex-coat_of_arms-61ffc43db19723c848ee45d2164adb35.svg";